import React,{Component} from 'react';

import {
  Container,
  Row,
  Col,
  Nav,
  NavLink,
  NavItem
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import AdjoyApproveCampaign from '../../AdjoyApproveCampaign';
import CampaignSpecialPricing from '../../CampaignSpecialPricing';
import CampaignResultsPrint from '../../CampaignResultsPrint';
import ProviderCampaignPublishers from '../../ProviderCampaignPublishers';

class ProviderCampaignView extends Component {
  constructor(){
    super();

    this.state = {
      isLoading:false
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});

    Promise.all([
      this.props.loadCampaign(this.props.campaignId),
      this.props.loadAccountHistory(this.props.campaignId)
    ])
      .then(() => this.setState({isLoading:false}))
  }

  getCampaignName(){
    if(this.props.needsLoading) return 'Loading...';
    if(this.props.name === '') return 'Untitled Campaign';
    return this.props.name;
  }

  render(){
    const { needsLoading, match, campaignId } = this.props;
    const { isLoading } = this.state;

    return (
      <Container>
        <Row>
          <Col xs='12'>
            <br />
            <h6>Experience</h6>
            <h3>{this.getCampaignName()}</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/pricing`}
                  activeClassName='active'
                >
                  Special Pricing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/review`}
                  activeClassName='active'
                >
                  Review & Approve
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/reports`}
                  activeClassName='active'
                >
                  Results
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/publishers`}
                  activeClassName='active'
                >
                  Publishers
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        {!needsLoading && !isLoading && (
          <Switch>
            <Route
              path={`${match.url}/review`}
              render={() => (<AdjoyApproveCampaign campaignId={campaignId} />)}
            />
            <Route
              path={`${match.url}/pricing`}
              render={() => (<CampaignSpecialPricing campaignId={campaignId} />)}
            />
            <Route
              path={`${match.url}/reports`}
              render={() => (<CampaignResultsPrint campaignId={campaignId} />)}
            />
            <Route
              path={`${match.url}/publishers`}
              render={() => (<ProviderCampaignPublishers campaignId={campaignId} />)}
            />
          </Switch>
        )}
      </Container>
    )
  }
}

export default ProviderCampaignView;



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignView/components/ProviderCampaignView.js